import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ITranslation } from 'src/app/classes/ITranslation';
import { SettingsmanagerService } from 'src/app/services/settingsmanager.service';

@Component({
  selector: 'app-create-translation',
  templateUrl: './create-translation.component.html',
  styleUrls: ['./create-translation.component.scss']
})
export class CreateTranslationComponent implements OnInit {
  @Input() entityId: string;
  @Input() entityType: string;
  @Input() localeOptions: { value: string; name: string }[] = [];
  @Input() labelOptions: { value: string; name: string }[] = [];

  @Output() onCancel = new EventEmitter<void>();
  @Output() onCreate = new EventEmitter<Pick<ITranslation, 'locale' | 'field' | 'value'>>();

  public addTranslationForm: FormGroup;
  public validation_messages = null;

  constructor(private fb: FormBuilder, private settingsManager: SettingsmanagerService) {}

  ngOnInit() {
    this.addTranslationForm = this.fb.group({
      locale: ['', Validators.compose([Validators.required])],
      field: ['', Validators.compose([Validators.required])],
      value: ['', Validators.compose([Validators.required])]
    });

    this.validation_messages = {
      locale: [{ type: 'required', message: 'Field is required.' }],
      field: [{ type: 'required', message: 'Field is required.' }],
      value: [{ type: 'required', message: 'Field is required.' }]
    };
  }

  cancelCreate() {
    this.addTranslationForm.reset();
    this.onCancel.emit();
  }

  onSubmit() {
    const formValue = this.addTranslationForm.value;
    // Trim dei valori per rimuovere spazi bianchi
    const sanitizedValue = {
      locale: formValue.locale ? formValue.locale.trim() : '',
      field: formValue.field ? formValue.field.trim() : '',
      value: formValue.value ? formValue.value.trim() : ''
    };
    console.log('Form values before submit:', sanitizedValue);
    this.onCreate.emit(sanitizedValue);
  }
}
